import React, { useContext, useEffect, useMemo } from "react";
import { FaPhoneVolume } from "react-icons/fa";
import { AiOutlineCalendar } from "react-icons/ai";
import { Link } from "react-router-dom";
import { NoImage } from "../Images";
import CommonContext from "../Context/context";
import { helperText } from "../Helper/helperFunctions";
import ReactHtmlParser from "react-html-parser";
const About = () => {
  const { cmsData, ContactNumber, GlobalData } = useContext(CommonContext);
  const cmsDataFor = cmsData?.find((ele) => ele?.page == "About Us");
  const FImage = useMemo(
    () => GlobalData?.find((ele) => ele?.title == "about_Us_Front_Image")?.file,
    [GlobalData]
  );
  const RImage = useMemo(
    () => GlobalData?.find((ele) => ele?.title == "about_Us_Rare_Image")?.file,
    [GlobalData]
  );

  const Chronological_Development_Image = GlobalData?.find(
    (ele) => ele?.title === "Chronological_Development_Image"
  );

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="content-box">
            <div className="content-wrapper">
              <div className="title">
                <h1>About Us</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="about-section about-inner-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="image-block">
                <div className="image-one">
                  <img src={FImage || NoImage} alt="front" />
                </div>
                <div className="image-two">
                  <img src={RImage || NoImage} alt="rare" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="content-block">
                <div className="sec-title mb-4">
                  <div className="text sub-title">About Us</div>
                  {cmsDataFor?.description
                    ? ReactHtmlParser(cmsDataFor?.description)
                    : helperText}
                </div>
                <div className="bottom-content">
                  <h4>Call Us</h4>
                  <div className="contact-number">
                    <Link to="/">
                      <div className="call">
                        <FaPhoneVolume />
                      </div>
                      {ContactNumber?.file || "0000000000"}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="step-bg">
        <div className="step-bg-1"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h2>Chronological Development</h2>
              <div className="d-flex">
                <ul className="steps-list">
                  <li className="steps-item">
                    <h3>Inauguration of the School</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      18 May 1995
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Extension of School Bldgs</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      30 April 2005
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>1 st Educational Excursion</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      25 Dec 2007
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Upgraded to U.Pry School</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      02 May 2008
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Opening up Br.Instn. Ankhona</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      07 Feb 2011
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Upgradation of Madhyamik</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      02 Jan 2012
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Inauguration of New Campus</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      25 Dec 2012
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Provisional Govt. Recognition</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      27 Jun 2013
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>1st M.P Exam Appearance</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      25 Feb 2014
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Opening 2nd Br. at Farakka</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      27 Jan 2018
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>School ERP/ Online Mgmt</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      01 Apr 2019
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Upgradation to H.S School</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      01 July 2019
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Lab for Science & Geography</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      15 Aug 2019
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Banglar Siksha Portal Entry</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      02 Jan 2022
                    </p>
                  </li>
                  <li className="steps-item">
                    <h3>Website of the Org. Launched</h3>
                    <p className="mb-0">
                      <AiOutlineCalendar />
                      01 July 2023
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="chronological-bg">
                <img src={Chronological_Development_Image?.file} alt="CHRONO" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
